// extracted by mini-css-extract-plugin
module.exports = {"root":"Subheader_root__3Ry4_","title":"Subheader_title__zopWp","description":"Subheader_description__3dKDc"};